import {ClsUsuarioCompartir} from '../cls-presupuestos';
import {ClsAccessToken} from '../cls-access-token';
import {ClsErrores} from '../cls-errores';
import {ClsPeticionPresupuestos} from './cls-pr-generico';

export class ClsPeticionCompartirPpto extends ClsUsuarioCompartir {
  AccessToken: ClsAccessToken;
}

export class ClsRespuestaObtieneUsuarioCompartidosPpto {
  UsuariosCompartidos: ClsUsuarioCompartir[];
  Errores: ClsErrores;
}

export class ClsPeticionRespuestaBorrarUsuarioCompartirPpto {
  AccessToken: ClsAccessToken;
  IdPresupuestoXUsuario: bigint;
  Errores?: ClsErrores;
}

export class ClsRespuestaGenerarArchivoIntercambio {
  ArchivoIntercambio: string;
  NombreArchivo: string;
  MensajeError?: string;
  Errores?: ClsErrores;
}

export class ClsPeticionRecibirArchivoIntercambio extends ClsPeticionPresupuestos {
  ArchivoIntercambioB64: string;
  NombreArchivo: string;
}

export class ClsPeticionUnirArchivosIntercambios extends ClsPeticionPresupuestos {
  LsArchivoIntercambioB64: ClsUnirArchivosIntercambios[];
}

export class ClsUnirArchivosIntercambios {
  ArchivoIntercambioB64: string;
  NombreArchivo: string;
}
